import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { type ReactNode } from 'react';

import Chevron from '@/assets/svg/chevron-left.svg?react';
import { Link } from '@/components/typography';

type RouteProps = {
  route: string;
  routeName: ReactNode;
  previousPage?: never;
};

type PreviousPageProps = {
  previousPage: boolean;
  route?: never;
  routeName?: never;
};

type Props = RouteProps | PreviousPageProps;

export const ReturnToLink = ({ previousPage, route, routeName }: Props) => {
  const contents = (
    <div className="flex items-center gap-2 whitespace-nowrap">
      <Chevron />
      <Trans>Return to {previousPage ? t`previous page` : routeName}</Trans>
    </div>
  );

  if (previousPage) {
    return (
      <Link className="leading-6!" previousPage>
        {contents}
      </Link>
    );
  }

  return (
    <span className="items-start">
      <Link className="leading-6!" to={route!}>
        {contents}
      </Link>
    </span>
  );
};
